export const REQUEST_DASHBOARD_DATED_SALES_STATISTICS =
  "REQUEST_DASHBOARD_DATED_SALES_STATISTICS";
export const REQUEST_DASHBOARD_DATED_SALES_STATISTICS_DONE =
  "REQUEST_DASHBOARD_DATED_SALES_STATISTICS_DONE";

export interface FetchDashboardDatedSalesStatistics {
  type: typeof REQUEST_DASHBOARD_DATED_SALES_STATISTICS;
  payload: any[];
}

export interface FetchDashboardDatedSalesStatisticsDone {
  type: typeof REQUEST_DASHBOARD_DATED_SALES_STATISTICS_DONE;
  payload: any[];
}

export interface DashboardDatedSalesStatisticsState {
  isLoading: boolean;
  datedSalesStatistics: any[];
}

export type DashboardDatedSalesStatisticsActions =
  | FetchDashboardDatedSalesStatistics
  | FetchDashboardDatedSalesStatisticsDone;
